import styles from "./DealerStyles.module.css";
import { useAuth } from "../../context/Auth";
import { useEffect, useRef, useState } from "react";

const SlidingFilter2 = ({
  itemList,
  bgcolor,
  setFilter,
  selectedItem,
  enableKeyboardNavigation = false,
}) => {
  const { mode } = useAuth();
  const itemRefs = useRef([]);

  const [focusedIndex, setFocusedIndex] = useState(() =>
    Math.max(0, itemList.indexOf(selectedItem))
  );

  useEffect(() => {
    if (enableKeyboardNavigation) {
      itemRefs.current[focusedIndex]?.focus();
    }
  }, [focusedIndex, enableKeyboardNavigation]);

  const handleKeyDown = (e) => {
    if (!enableKeyboardNavigation) return;

    if (e.key === "ArrowRight") {
      e.preventDefault();
      const nextIndex = (focusedIndex + 1) % itemList.length;
      setFocusedIndex(nextIndex);
      setFilter(itemList[nextIndex]);
    } else if (e.key === "ArrowLeft") {
      e.preventDefault();
      const prevIndex = (focusedIndex - 1 + itemList.length) % itemList.length;
      setFocusedIndex(prevIndex);
      setFilter(itemList[prevIndex]);
    }
  };

  const handleItemClick = (item, index) => {
    setFocusedIndex(index);
    setFilter(item);
  };

  return (
    <div
      className={mode ? styles.sliding_filter_dark : styles.sliding_filter}
      onKeyDown={handleKeyDown}
      tabIndex={enableKeyboardNavigation ? 0 : undefined}
    >
      <ul
        className={styles.sliding_filter_list}
        style={{
          backgroundColor: mode ? "#1B1D21" : "#fff",
          color: mode ? "#fff" : "#000",
          ...(bgcolor ? { border: `1px solid ${bgcolor}` } : {}),
        }}
      >
        {itemList.map((item, index) => (
          <li
            key={index}
            ref={(el) => (itemRefs.current[index] = el)}
            className={`${styles.sliding_filter_item} ${
              item === selectedItem ? styles.sliding_selected_item : ""
            }`}
            tabIndex={-1}
            onClick={() => handleItemClick(item, index)}
            style={
              item === selectedItem
                ? bgcolor
                  ? { backgroundColor: bgcolor }
                  : mode
                  ? { backgroundColor: "#000", color: "#fff" }
                  : { backgroundColor: "#000", color: "#fff" }
                : {
                    backgroundColor: "transparent",
                    color: mode ? "#fff" : "#000",
                  }
            }
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SlidingFilter2;
